import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  RequiredTrackedValueString1,
  TrackedValueString,
  TrackedValueString1,
} from '../../../../data/models/_generatedUblInvoice'

type Props = {
  trackedValue?:
    | TrackedValueString
    | TrackedValueString1
    | RequiredTrackedValueString1
  formikValue?: unknown
}

export const ValueStatus: React.FC<Props> = ({ trackedValue, formikValue }) => {
  const { t } = useTranslation()

  const currentValue = formikValue ? formikValue : trackedValue?.Value
  const originalValue = trackedValue?.OriginalValue || ''

  const isEmpty = !currentValue && !originalValue
  const isAdded = !originalValue && currentValue
  const isEdited = currentValue !== originalValue
  const isIdentical = currentValue === originalValue

  if (isEmpty) {
    return <></>
  }

  if (isAdded)
    return (
      <span className="text-sm text-green-700 flex gap-1">
        <span className="border-circle bg-green-500 w-1rem h-1rem">
          <span className="pi pi-plus-circle text-white"></span>
        </span>

        {t('eInvoiceDetails.common.form.added')}
      </span>
    )

  if (isEdited)
    return (
      <span className="text-sm text-orange-700 flex gap-1">
        <span className="border-circle bg-orange-500 w-1rem h-1rem">
          <span className="pi pi-exclamation-circle text-white"></span>
        </span>

        {t('eInvoiceDetails.common.form.edited')}
      </span>
    )

  if (isIdentical)
    return (
      <span className="text-sm text-400">
        {t('eInvoiceDetails.common.form.original')}
      </span>
    )

  return <></>
}
